<div class="relative w-full h-full">
  <div *ngIf="!isLoading" class="w-full h-full">
    <ig-google-map class="ig-event-map" class="w-full h-full" [markers]="placesAndMarkers.markers" [center]="mapCenter"
      (onclick)="isShowDetails=false;showingEvent=null" (onMarkerClick)="markerClicked($event)"></ig-google-map>

    <!-- <div [class.hidden]="isShowDetails"
      class="absolute bottom-[23rem] left-[10%] p-4 text-lg font-black text-gray-700 mobile:hidden"
      style="backdrop-filter:blur(1px)">{{placesAndMarkers.places.length}} Places IN ALL</div> -->

    <!-- <div [class.opacity-0]="isShowDetails" [class.h-0]="isShowDetails" -->
    <div class="absolute bottom-2 w-[90%] pb-0 left-[5%] mobile:bottom-16 mobile:left-[5%] mobile:w-[87%]">
      <div *ngIf="allPlaces.places.length > paging" class="flex justify-start mb-2">
        <div class="flex items-center gap-3 bg-[#0000004f] rounded-3xl px-4 py-2 text-white ml-[6.5rem]">
          <div class="font-semibold">Showing result {{showingCount}}</div>
          <mat-icon class="text-[36px] !w-9 !h-9 text-gray-500 rounded-full bg-gray-100 relative z-50"
            [class.text-gray-200]="isAtStart" [class.cursor-pointer]="!isAtStart" (click)="goLeft()">chevron_left
          </mat-icon>
          <mat-icon class="text-[36px] !w-9 !h-9 text-gray-500 rounded-full bg-gray-100 relative z-50"
            [class.text-gray-200]="isAtEnd" [class.cursor-pointer]="!isAtEnd" (click)="goRight()">chevron_right
          </mat-icon>
        </div>
      </div>

      <div class="flex items-center gap-6 px-4 py-2 text-white">
        <mat-icon
          class="places-row-icon text-[36px] !w-9 !h-9 rounded-full bg-[#0000004f] px-4 py-2 text-white relative z-50"
          [class.text-gray-200]="isAtStart" [class.opacity-20]="isAtStart" [class.cursor-not-allowed]="isAtStart"
          [class.cursor-pointer]="!isAtStart" (click)="goLeftBy1Place()">
          chevron_left
        </mat-icon>
        <div #eventsRow h-scroll
          class="flex gap-8 w-full pb-2 overflow-auto mobile:w-[90%] mobile:left-[5%] mobile:gap-3 relative">
          <div class="flex items-center">


            <div class="flex gap-8 scroll-smooth custom-scrollbar" #scrollContainer>
              <div #event *ngFor="let event of placesAndMarkers.places" [attr.data-id]="event._id"
                class="p-2 bg-white rounded-xl min-w-[16rem] max-w-[16rem] shadow-md relative cursor-pointer outline-orange-400 -outline-offset-4 outline-4 mobile:min-w-[14rem] mobile:max-w-[14rem]"
                igClickStopPropagation (click)="showDetails(event)"
                [class.outline]="showingEvent&&showingEvent._id===event._id">
                <!-- Existing place card content -->
                <div class="relative">
                  <ig-image [src]="event.cover?.source" class="w-full" cls="aspect-[2/1] rounded-xl"></ig-image>
                  <div
                    class="w-full h-1/2 absolute bottom-0 left-0 rounded-2xl bg-gradient-to-b from-transparent to-black">
                  </div>
                  <div
                    class="text-white text-base font-semibold overflow-hidden max-lines-2 absolute w-full bottom-2 mx-3 leading-[1.2rem] mobile:text-sm mobile:font-normal">
                    {{event.name}}
                  </div>
                </div>
                <div class="text-gray-400 text-sm overflow-hidden max-lines-1">
                  <mat-icon class="text-lg relative top-1.5">list</mat-icon>{{event.categoryText}}
                </div>
                <div class="text-gray-400 text-sm overflow-hidden max-lines-2 mobile:text-xs mobile:-mt-1">
                  <mat-icon class="text-lg relative top-1.5">room</mat-icon>{{event.address?.address}}
                </div>
              </div>
            </div>

          </div>
        </div>
        <mat-icon
          class="places-row-icon text-[36px] !w-9 !h-9 rounded-full bg-[#0000004f] px-4 py-2 text-white relative z-50"
          [class.text-gray-200]="isAtEnd" [class.opacity-20]="isAtEnd" [class.cursor-not-allowed]="isAtEnd"
          [class.cursor-pointer]="!isAtEnd" (click)="goRightBy1Place()">
          chevron_right
        </mat-icon>
      </div>

    </div>
  </div>

  <div *ngIf="showingPlace"
    class="w-[400px] max-w-full h-full border-l-4 border-solid absolute -right-[400px] -top-2 transition-all overflow-y-auto mobile:!bg-white mobile:top-0"
    [class.!right-0]="isShowDetails" style="backdrop-filter:blur(56px)">
    <ig-place-details-side-modal [place]="showingPlace" (back)="isShowDetails=false;showingPlace=null">
    </ig-place-details-side-modal>
  </div>

  <ng-template #loading>
    <div id="skeleton-mask-cards" class="absolute top-0 left-0 w-full h-full bg-[#eef5f9] flex flex-col">
      <img src="https://iti-images.s3.amazonaws.com/imgs/map.png" alt="" class="h-3/5 mx-auto object-cover">
      <div class="px-[3vw] py-[1vw]">
        <ig-loading-block [rows]="1" [columns]="4"></ig-loading-block>
      </div>
    </div>
  </ng-template>
</div>